import axios from 'axios';
import store from '@/store';
import router from '@/router';
import moment from 'moment';
import appError from '@/error/appError';

const BASE_API_URL = process.env.VUE_APP_URL_API ? process.env.VUE_APP_URL_API : '/api/';
const MINUTES_SESSION_TIMEOUT = 30; // en minutos
const apiService = axios.create({
  baseURL: BASE_API_URL,
  // timeout: 5000,
  headers: { 'Content-Type': 'application/json' }
  //rejectUnauthorized: false
  // withCredentials:true
});
apiService.interceptors.request.use(request => {
  let expired = false;
  if (store.getters.timeLastAPICall) {
    expired = moment().diff(store.getters.timeLastAPICall) > MINUTES_SESSION_TIMEOUT * 60 * 1000;
  }

  store.dispatch('setTimeLastAPICall');
  if (expired) {
    store.dispatch('sessionExpired', true); // importante primero esta acción
    store.dispatch('logout');
    return Promise.reject(appError.instance('Su sesión ha caducado', true));
  }
  return request;
});

apiService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 403) {
      router.replace('/403');
      return Promise.reject(appError.instance('Acceso no permitido al recurso', true));
    } else {
      return Promise.reject(error);
    }
  }
);

/*
import { token } from '@/utils/token'
import logger from '@/utils/logger'

apiService.interceptors.request.use (config => {
  if (store.getters.token) {
    config.headers['X-Token'] = getToken();
  }
  return config;
}, error => {
  logger.print(error);
  return Promise.reject("Perdida comunicación con el servidor")
})
*/

export default apiService;
